/** @format */
export const OAUTH_ERROR_PARAM = 'error';
